/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type RegionsEnum = (typeof RegionsEnum)[keyof typeof RegionsEnum];

export const RegionsEnum = {
  NUMBER_1084: 1084,
  NUMBER_1082: 1082,
  NUMBER_1081: 1081,
  NUMBER_1085: 1085,
  NUMBER_1083: 1083,
} as const;
